import React from 'react';

const Header = () => {
  return (
    <header className="bg-blue-800 text-white p-4 shadow-lg">
      <h1 className="text-3xl font-bold">Job Posting Board</h1>
    </header>
  );
};

export default Header;
